import { isDefined } from "@grandvisionhq/utils";
import { mapServerToVariantBase } from "./map-server-to-variant-base.js";
import { getSharedFrameVariantProps } from "../../../shared/mappers/server-to-client/variant-mappers/shared/get-shared-frame-variant-props.js";
import { getBrandModelAttributes } from "../../../../utils/mappers/server-to-client/utils/get-brand-model-attributes.js";
import { getSunglassesProductFeatures } from "../../../../utils/product-feature-mappers/mappers/server-to-client/utils/product-feature-mappers/get-sunglasses-product-features.js";
import { mapServerToSunglassesSpecifications } from "../../../../specification-mappers/mappers/server-to-client/specification-mappers/map-server-to-sunglasses-specifications.js";
import { getFaceShapes } from "../../../../utils/mappers/server-to-client/utils/get-face-shapes.js";
const mapServerToSunglassesVariant = (serverProduct, slug, locale, priceSegmentChannelKey) => {
  const { variants: serverVariants } = serverProduct;
  if (!serverVariants || !serverVariants.length) {
    return;
  }
  const clientVariants = serverVariants.map((serverVariant) => {
    const variantBase = mapServerToVariantBase(
      serverVariant,
      serverProduct,
      slug,
      locale,
      priceSegmentChannelKey
    );
    if (!variantBase) return;
    const { variantTypeDetails } = serverVariant;
    const { brand } = serverProduct;
    const brandModelAttributes = getBrandModelAttributes(serverVariant);
    const productFeatures = getSunglassesProductFeatures(variantTypeDetails.lensFeatures ?? {});
    const specifications = mapServerToSunglassesSpecifications(
      serverVariant,
      brand,
      locale,
      !!serverProduct.productTypeDetails.isOfferedWithPrescriptions
    );
    const sunglasses = {
      ...variantBase,
      ...getSharedFrameVariantProps(variantTypeDetails),
      ...brandModelAttributes,
      variantType: "sunglasses",
      faceShapes: getFaceShapes(variantTypeDetails.faceShape),
      productFeatures,
      specifications,
      isVtoEnabled: !!variantTypeDetails.isVtoEnabled,
      isReservable: variantTypeDetails.isReservable
    };
    return sunglasses;
  });
  return clientVariants.filter(isDefined);
};
export {
  mapServerToSunglassesVariant
};
//# sourceMappingURL=map-server-to-sunglasses-variant.js.map
